import React, { useState, useMemo, useEffect } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Link, useNavigate } from "react-router-dom";
import { 
  Card, 
  Table, 
  Row, 
  Col, 
  Form, 
  InputGroup, 
  Button, 
  Pagination, 
  Dropdown, 
  Badge, 
  Modal, 
  Alert, 
  Spinner, 
  Toast, 
  ToastContainer
} from "react-bootstrap";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import {
  Search,
 
  PlusCircle,
  Eye,
  FileText,
  Building,

  Download,
  Pencil,
  Trash,
  CheckCircle,
  XCircle,
  Envelope,
  Phone,
  ChevronDown,
  ChevronUp,
  ExclamationCircle,
  PauseCircle,
  Check,
  X,
  Map,

  Calendar,
  ArrowClockwise
} from "react-bootstrap-icons";

// Configuration API
const API_BASE_URL = process.env.REACT_APP_API_URL;

// Données de démo provenant de l'API
const demoEntites = [];

export default function EntitesList() {
  const navigate = useNavigate();
  
  // États principaux
  const [entites, setEntites] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortField, setSortField] = useState('created_at');
  const [sortDirection, setSortDirection] = useState('desc');
  const [selectedEntites, setSelectedEntites] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [useMockData, setUseMockData] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [adding, setAdding] = useState(false);
  const [deleting, setDeleting] = useState(false);
  
  // États pour les modals
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showUnblockModal, setShowUnblockModal] = useState(false);
  
  // États pour les données
  const [selectedEntite, setSelectedEntite] = useState(null);
  const [entiteToDelete, setEntiteToDelete] = useState(null);
  const [entiteToBlock, setEntiteToBlock] = useState(null);
  const [pagination, setPagination] = useState({
    current_page: 1,
    from: 0,
    last_page: 1,
    per_page: 10,
    to: 0,
    total: 0
  });

  // États pour les formulaires
  const [newEntite, setNewEntite] = useState({
    nom: '',
    adresse: '',
    telephone: '',
    email: '',
    type: 'entreprise',
    statut: 'active'
  });
  
  const [editEntite, setEditEntite] = useState({
    nom: '',
    adresse: '',
    telephone: '',
    email: '',
    type: '',
    statut: ''
  });

  // États pour les filtres
  const [selectedType, setSelectedType] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  
  // États pour les notifications
  const [notifications, setNotifications] = useState([]);
  const [alertMessage, setAlertMessage] = useState({ show: false, message: '', type: 'info' });

  // Types d'entités pour les filtres
  const types = [
    { value: "all", label: "Tous les types" },
    { value: "entreprise", label: "Entreprise" },
    { value: "commune", label: "Commune" },
    { value: "organisation", label: "Organisation" }
  ];

  // Statuts
  const statuses = [
    { value: "all", label: "Tous les statuts" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "suspended", label: "Suspendue" }
  ];

  // Obtenir le token d'authentification
  const getAuthToken = () => {
    const token = sessionStorage.getItem("authToken");
   
    return token;
  };

  // Headers pour les requêtes API
  const getHeaders = () => {
    const token = getAuthToken();
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    return headers;
  };

  // Transformer les données de l'API
  const transformApiData = (apiData) => {
    return apiData.map(entite => {
      return {
        id: entite.id,
        code: `ENT${String(entite.id).padStart(3, '0')}`,
        entite_id: entite.entite_id,
        nom: entite.nom || 'Nom non spécifié',
        type: 'Commune',
        email: entite.email || 'email@non-specifie.cd',
        telephone: entite.telephone || 'Non spécifié',
        adresse: entite.adresse || 'Adresse non spécifiée',
        statut: entite.deleted_at ? 'inactive' : 'active',
        dateCreation: entite.created_at ? entite.created_at.split('T')[0] : 'Non spécifiée',
        created_at: entite.created_at,
        updated_at: entite.updated_at,
        deleted_at: entite.deleted_at,
        users_count: entite.users_count || 0
      };
    });
  };

  // Fonction pour récupérer les entités
  const fetchEntites = async () => {
    try {
      setLoading(true);
      setError(null);
      
      
      // Délai artificiel pour simuler le chargement
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Vérifier si on doit utiliser les données mock
      if (useMockData) {
       
        const transformedEntites = transformApiData(demoEntites);
        setEntites(transformedEntites);
        showNotification('Données de démonstration chargées avec succès', 'success');
        return;
      }
      
      // Essayer de récupérer le token
      const token = getAuthToken();
      if (!token) {
        console.warn("Pas de token, utilisation des données de démonstration");
        setUseMockData(true);
        const transformedEntites = transformApiData(demoEntites);
        setEntites(transformedEntites);
        return;
      }
      
      try {
        // Configurer la requête avec timeout
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 10000);
        
        const response = await fetch(`${API_BASE_URL}/entites`, {
          method: 'GET',
          headers: getHeaders(),
          signal: controller.signal,
          mode: 'cors',
          credentials: 'include'
        });
        
        clearTimeout(timeoutId);
        
        
        if (!response.ok) {
          const errorText = await response.text();
        
          throw new Error(`Erreur HTTP ${response.status}: ${errorText}`);
        }
        
        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          const transformedEntites = transformApiData(data.data);
          setEntites(transformedEntites);
        } else if (data.data) {
          const transformedEntites = transformApiData(data.data);
          setEntites(transformedEntites);
        } else {
          throw new Error(data.message || 'Structure de données inattendue');
        }
        
      } catch (fetchError) {
        if (fetchError.name === 'AbortError') {
          console.warn("Requête annulée (timeout), utilisation des données de démonstration");
          setUseMockData(true);
          const transformedEntites = transformApiData(demoEntites);
          setEntites(transformedEntites);
          showNotification('Délai dépassé - sessionStorage', 'warning');
         
        } else {
          throw fetchError;
        }
      }
      
    } catch (error) {
     
      // En cas d'erreur, utiliser les données de démonstration
      setUseMockData(true);
      const transformedEntites = transformApiData(demoEntites);
      setEntites(transformedEntites);
      
      const errorMessage = error.message.includes('Failed to fetch') 
        ? 'Impossible de se connecter au serveur. sessionStorage activé.'
        : error.message;
      
      setError(errorMessage);
     
    } finally {
      setLoading(false);
    }
  };

  // Initialiser les données
  useEffect(() => {
    fetchEntites();
  }, []);

  // Fonctions pour les notifications
  const showNotification = (message, type = 'info', duration = 5000) => {
    const id = Date.now();
    const notification = {
      id,
      message,
      type,
      show: true
    };
    
    setNotifications(prev => [notification, ...prev]);
    
    setTimeout(() => {
      hideNotification(id);
    }, duration);
  };

  const hideNotification = (id) => {
    setNotifications(prev => prev.filter(notif => notif.id !== id));
  };

  const showAlert = (message, type = 'warning', duration = 5000) => {
    setAlertMessage({ show: true, message, type });
    
    if (duration > 0) {
      setTimeout(() => {
        hideAlert();
      }, duration);
    }
  };

  const hideAlert = () => {
    setAlertMessage({ show: false, message: '', type: 'info' });
  };

  // Filtrage et tri des données
  const filteredAndSortedItems = useMemo(() => {
    let filtered = entites.filter(item => {
      const searchTerm = filterText.toLowerCase();
      
      // Recherche textuelle
      const matchesSearch = 
        (item.nom && item.nom.toLowerCase().includes(searchTerm)) ||
        (item.code && item.code.toLowerCase().includes(searchTerm)) ||
        (item.telephone && item.telephone.includes(filterText)) ||
        (item.email && item.email.toLowerCase().includes(searchTerm)) ||
        (item.adresse && item.adresse.toLowerCase().includes(searchTerm));
      
      // Filtre par type
      if (selectedType !== 'all' && item.type !== selectedType) {
        return false;
      }
      
      // Filtre par statut
      if (selectedStatus !== 'all' && item.statut !== selectedStatus) {
        return false;
      }
      
      return matchesSearch;
    });

    // Tri
    filtered.sort((a, b) => {
      let aValue = a[sortField] || '';
      let bValue = b[sortField] || '';
      
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      
      if (sortDirection === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

    return filtered;
  }, [entites, filterText, selectedType, selectedStatus, sortField, sortDirection]);

  // Statistiques simples
  const stats = useMemo(() => {
    const total = entites.length;
    const actives = entites.filter(e => e.statut === "active").length;
    const entreprises = entites.filter(e => e.type === "entreprise").length;
    const communes = entites.filter(e => e.type === "commune").length;
    
    return { 
      total, 
      actives, 
      entreprises,
      communes
    };
  }, [entites]);

  // Pagination
  const totalPages = Math.ceil(filteredAndSortedItems.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredAndSortedItems.slice(startIndex, startIndex + itemsPerPage);

  // Fonctions de tri
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  // Gestion des sélections
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedEntites(currentItems.map(entite => entite.id));
    } else {
      setSelectedEntites([]);
    }
  };

  const handleSelectEntite = (entiteId) => {
    setSelectedEntites(prev => 
      prev.includes(entiteId) 
        ? prev.filter(id => id !== entiteId)
        : [...prev, entiteId]
    );
  };

  const isAllSelected = currentItems.length > 0 && selectedEntites.length === currentItems.length;
  const isSomeSelected = selectedEntites.length > 0 && selectedEntites.length < currentItems.length;

  // Fonctions de formatage
  const formatDate = (dateString) => {
    if (!dateString) return "Non spécifié";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (e) {
      return dateString;
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "Non spécifié";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return dateString;
    }
  };

  // Obtenir le badge de type
  const getTypeBadge = (type) => {
    const config = {
      commune: { label: "Commune", color: "primary", icon: <Building className="me-1" /> },
      entreprise: { label: "Entreprise", color: "success", icon: <Building className="me-1" /> },
      organisation: { label: "Organisation", color: "secondary", icon: <Building className="me-1" /> }
    };
    const cfg = config[type] || { label: type, color: "secondary", icon: <Building className="me-1" /> };
    return (
      <Badge bg={cfg.color} className="d-flex align-items-center px-2 py-1">
        {cfg.icon}
        {cfg.label}
      </Badge>
    );
  };

  // Obtenir le badge de statut
  const getStatusBadge = (statut) => {
    const config = {
      active: { label: "Active", color: "success", icon: <CheckCircle className="me-1" /> },
      inactive: { label: "Inactive", color: "secondary", icon: <XCircle className="me-1" /> },
      suspended: { label: "Suspendue", color: "warning", icon: <PauseCircle className="me-1" /> }
    };
    const cfg = config[statut] || { label: statut, color: "secondary", icon: null };
    return (
      <Badge bg={cfg.color} className="d-flex align-items-center px-2 py-1">
        {cfg.icon}
        {cfg.label}
      </Badge>
    );
  };

  // Gestion de l'ajout d'entité (mode démonstration)
  const handleAddEntite = () => {
    setNewEntite({
      nom: '',
      adresse: '',
      telephone: '',
      email: '',
      type: 'entreprise',
      statut: 'active'
    });
    setShowAddModal(true);
  };

  const handleSaveEntite = () => {
    // Validation
    if (!newEntite.nom.trim() || !newEntite.telephone.trim()) {
      showAlert("Veuillez remplir les champs obligatoires (nom et téléphone)", 'warning');
      return;
    }

    // Générer un ID unique
    const maxId = entites.length > 0 ? Math.max(...entites.map(e => e.id)) : 0;
    const newId = maxId + 1;
    
    // Générer un entite_id unique
    const newEntiteId = Date.now();
    
    // Ajouter la nouvelle entité (mode démonstration)
    const newEntiteData = {
      id: newId,
      entite_id: newEntiteId,
      code: `ENT${String(newId).padStart(3, '0')}`,
      nom: newEntite.nom,
      type: newEntite.type,
      email: newEntite.email,
      telephone: newEntite.telephone,
      adresse: newEntite.adresse,
      statut: newEntite.statut,
      dateCreation: new Date().toISOString().split('T')[0],
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      deleted_at: null,
      users_count: 0
    };
    
    setEntites(prev => [...prev, newEntiteData]);
    setShowAddModal(false);
    showNotification('Entité ajoutée avec succès (mode démonstration)', 'success');
  };

  // Gestion de l'édition d'entité (mode démonstration)
  const handleEditEntite = (entite) => {
    setSelectedEntite(entite);
    setEditEntite({
      nom: entite.nom,
      adresse: entite.adresse || '',
      telephone: entite.telephone,
      email: entite.email || '',
      type: entite.type || 'entreprise',
      statut: entite.statut || 'active'
    });
    setShowEditModal(true);
  };

  const handleUpdateEntite = async () => {
    if (!selectedEntite) return;

    // Validation
    if (!editEntite.nom.trim() || !editEntite.telephone.trim()) {
      showAlert("Veuillez remplir les champs obligatoires (nom et téléphone)", 'warning');
      return;
    }

    setUpdating(true);

    try {
      // En mode démonstration
      if (useMockData) {
        // Simuler un délai pour voir le loading
        await new Promise(resolve => setTimeout(resolve, 800));
        
        const updatedEntites = entites.map(e => 
          e.id === selectedEntite.id 
            ? { 
                ...e, 
                ...editEntite,
                updated_at: new Date().toISOString()
              }
            : e
        );

        setEntites(updatedEntites);
        setShowEditModal(false);
        showNotification('Entité mise à jour avec succès (mode démonstration)', 'success');
        return;
      }

      // En mode API
      const token = getAuthToken();
      if (!token) {
        showAlert("Session expirée. Veuillez vous reconnecter.", 'warning');
        return;
      }

      // Préparer les données pour l'API
      const requestData = {
        nom: editEntite.nom.trim(),
        adresse: editEntite.adresse || '',
        telephone: editEntite.telephone.trim(),
        email: editEntite.email || '',
        statut: editEntite.statut
      };

     
      // Appel API PUT
      const response = await fetch(`${API_BASE_URL}/entites/${selectedEntite.entite_id}`, {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify(requestData),
        mode: 'cors',
        credentials: 'include'
      });

      

      if (!response.ok) {
        const errorData = await response.text();
       
        throw new Error(`Erreur HTTP ${response.status}: ${errorData}`);
      }

      const result = await response.json();
     

      if (result.code === 200 || result.success) {
        // Mettre à jour l'état local
        const updatedEntites = entites.map(e => 
          e.entite_id === selectedEntite.entite_id 
            ? { 
                ...e, 
                ...editEntite,
                updated_at: new Date().toISOString(),
                nom: editEntite.nom,
                adresse: editEntite.adresse,
                telephone: editEntite.telephone,
                email: editEntite.email,
                statut: editEntite.statut
              }
            : e
        );

        setEntites(updatedEntites);
        setShowEditModal(false);
        
        const message = result.message || 'Entité mise à jour avec succès';
        showNotification(message, 'success');
      } else {
        throw new Error(result.message || 'Erreur lors de la mise à jour');
      }

    } catch (error) {
      
      // En cas d'erreur, passer en mode démonstration
      if (!useMockData) {
        showAlert(`Erreur API: ${error.message}. Utilisation du mode démonstration.`, 'warning');
        setUseMockData(true);
        
        const updatedEntites = entites.map(e => 
          e.id === selectedEntite.id 
            ? { 
                ...e, 
                ...editEntite,
                updated_at: new Date().toISOString()
              }
            : e
        );

        setEntites(updatedEntites);
        setShowEditModal(false);
        showNotification('Entité mise à jour (mode démonstration)', 'warning');
      } else {
        showAlert(`Erreur: ${error.message}`, 'danger');
      }
    } finally {
      setUpdating(false);
    }
  };

  // Gestion de la suppression
  const handleDeleteEntite = (entite) => {
    setEntiteToDelete(entite);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!entiteToDelete) return;
    setDeleting(true);
    
    try {
      // En mode démonstration
      if (useMockData) {
        setEntites(prev => prev.filter(e => e.id !== entiteToDelete.id));
        setShowDeleteModal(false);
        showNotification('Entité supprimée avec succès (mode démonstration)', 'success');
        return;
      }

      // En mode API
      const token = getAuthToken();
      if (!token) {
        showAlert("Session expirée. Veuillez vous reconnecter.", 'warning');
        return;
      }

      // Appel API DELETE
      const response = await fetch(`${API_BASE_URL}/entites/${entiteToDelete.entite_id}`, {
        method: 'DELETE',
        headers: getHeaders(),
        mode: 'cors',
        credentials: 'include'
      });

    
      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(`Erreur HTTP ${response.status}: ${errorData}`);
      }

      const result = await response.json();
      
      if (result.code === 200 || result.success) {
        // Mettre à jour l'état local
        setEntites(prev => prev.filter(e => e.entite_id !== entiteToDelete.entite_id));
        setShowDeleteModal(false);
        
        const message = result.message || 'Entité supprimée avec succès';
        showNotification(message, 'success');
      } else {
        throw new Error(result.message || 'Erreur lors de la suppression');
      }

    } catch (error) {
      
      // En cas d'erreur, passer en mode démonstration
      if (!useMockData) {
        showAlert(`Erreur API: ${error.message}. Utilisation du mode démonstration.`, 'warning');
        setUseMockData(true);
        
        setEntites(prev => prev.filter(e => e.id !== entiteToDelete.id));
        setShowDeleteModal(false);
        showNotification('Entité supprimée (mode démonstration)', 'warning');
      } else {
        showAlert(`Erreur: ${error.message}`, 'danger');
      }
    } finally {
      setDeleting(false);
    }
  };

  // Gestion de la suppression multiple
  const handleBulkDelete = () => {
    if (selectedEntites.length === 0) {
      showAlert("Veuillez sélectionner au moins une entité", 'warning');
      return;
    }
    setShowBulkDeleteModal(true);
  };

  const handleConfirmBulkDelete = () => {
    setEntites(prev => prev.filter(e => !selectedEntites.includes(e.id)));
    setSelectedEntites([]);
    setShowBulkDeleteModal(false);
    showNotification(`${selectedEntites.length} entité(s) supprimée(s) avec succès (mode démonstration)`, 'success');
  };

  // Gestion du blocage/déblocage
  const handleBlockEntite = (entite) => {
    setEntiteToBlock(entite);
    setShowBlockModal(true);
  };

  const handleUnblockEntite = (entite) => {
    setEntiteToBlock(entite);
    setShowUnblockModal(true);
  };

  const handleConfirmBlock = () => {
    if (!entiteToBlock) return;

    const updatedEntites = entites.map(e => 
      e.id === entiteToBlock.id 
        ? { 
            ...e, 
            statut: 'inactive',
            updated_at: new Date().toISOString()
          }
        : e
    );

    setEntites(updatedEntites);
    setShowBlockModal(false);
    showNotification('Entité bloquée avec succès (mode démonstration)', 'warning');
  };

  const handleConfirmUnblock = () => {
    if (!entiteToBlock) return;

    const updatedEntites = entites.map(e => 
      e.id === entiteToBlock.id 
        ? { 
            ...e, 
            statut: 'active',
            updated_at: new Date().toISOString()
          }
        : e
    );

    setEntites(updatedEntites);
    setShowUnblockModal(false);
    showNotification('Entité débloquée avec succès (mode démonstration)', 'success');
  };

  // Fonctions d'export
  const handleExport = (format) => {
    setExportLoading(true);
    const dataToExport = selectedEntites.length > 0
      ? entites.filter(entite => selectedEntites.includes(entite.id))
      : filteredAndSortedItems;

    if (!dataToExport.length) { 
      showAlert("Aucune donnée à exporter", 'warning', 4000);
      setExportLoading(false); 
      return; 
    }

    try {
      // Préparation des données pour l'export
      const enhancedData = dataToExport.map(entite => ({
        ID: entite.id,
        "ID Entité": entite.entite_id,
        Code: entite.code,
        Nom: entite.nom,
        Type: entite.type === 'commune' ? 'Commune' : 
              entite.type === 'entreprise' ? 'Entreprise' : 'Organisation',
        Email: entite.email,
        Téléphone: entite.telephone,
        Adresse: entite.adresse,
        Statut: entite.statut === 'active' ? 'Active' : 
                entite.statut === 'inactive' ? 'Inactive' : 'Suspendue',
        "Date création": formatDate(entite.created_at),
        "Dernière modification": formatDate(entite.updated_at),
        "Utilisateurs": entite.users_count || 0
      }));

      if (format === "csv") {
        const headers = Object.keys(enhancedData[0]);
        const csvContent = [
          "\uFEFF" + headers.join(";"),
          ...enhancedData.map(e => Object.values(e).map(v => `"${v || ''}"`).join(";"))
        ].join("\n");
        downloadFile(csvContent, "text/csv;charset=utf-8;", `export-entites-${Date.now()}.csv`);

      } else if (format === "excel") {
        const ws = XLSX.utils.json_to_sheet(enhancedData);
        const columnWidths = [
          { wch: 8 }, { wch: 12 }, { wch: 10 }, { wch: 25 }, { wch: 15 },
          { wch: 25 }, { wch: 15 }, { wch: 30 }, { wch: 10 }, { wch: 15 },
          { wch: 15 }, { wch: 10 }
        ];
        ws['!cols'] = columnWidths;
        
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Entités");
        XLSX.writeFile(wb, `export-entites-${Date.now()}.xlsx`);

      } else if (format === "json") {
        downloadFile(JSON.stringify(enhancedData, null, 2), "application/json;charset=utf-8;", `export-entites-${Date.now()}.json`);

      } else if (format === "pdf") {
        generatePDF(enhancedData);
      }

      showNotification(
        `Export ${format.toUpperCase()} réussi - ${dataToExport.length} enregistrement(s)`,
        'success',
        4000
      );
    } catch (error) {
      showAlert(
        `Erreur lors de l'export: ${error.message}`,
        'error',
        6000
      );
    } finally {
      setExportLoading(false);
    }
  };

  // Fonction pour générer PDF
  const generatePDF = (data) => {
    try {
      const doc = new jsPDF('p', 'mm', 'a4');
      
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 15;
      let yPosition = margin;
      
      // Palette de couleurs
      const primaryColor = [44, 62, 120];
      const softGray = [245, 246, 248];
      const darkText = [40, 40, 40];
      const successColor = [40, 167, 69];
      const warningColor = [255, 193, 7];
      const dangerColor = [220, 53, 69];
      
      // ===== EN-TÊTE =====
      doc.setFillColor(...primaryColor);
      doc.rect(0, 0, pageWidth, 40, "F");
      
      // Titre
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(20);
      doc.setFont('helvetica', 'bold');
      doc.text("LISTE DES ENTITÉS", pageWidth / 2, 15, { align: "center" });
      
      // Sous-titre
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.text(
        `Rapport généré le ${new Date().toLocaleDateString('fr-FR')}`,
        pageWidth / 2,
        25,
        { align: "center" }
      );
      
      // Informations statistiques
      doc.setFontSize(9);
      doc.text(
        `${entites.length} entité(s) • ${useMockData ? 'Mode démonstration' : 'Données réelles'}`,
        pageWidth / 2,
        33,
        { align: "center" }
      );
      
      yPosition = 50;
      
      // ===== STATISTIQUES =====
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...darkText);
      doc.text("SYNTHÈSE", margin, yPosition);
      
      yPosition += 10;
      
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      
      const statsText = [
        `• Nombre d'entités: ${entites.length}`,
        `• Actives: ${stats.actives}`,
        `• Inactives: ${entites.length - stats.actives}`,
      ];
      
      statsText.forEach(line => {
        doc.text(line, margin, yPosition);
        yPosition += 5;
      });
      
      yPosition += 10;
      
      // ===== TABLEAU PRINCIPAL =====
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      doc.text("LISTE DÉTAILLÉE DES ENTITÉS", margin, yPosition);
      yPosition += 10;
      
      // En-têtes du tableau
      const headers = ["CODE", "NOM", "TYPE", "CONTACT", "STATUT"];
      const columnWidths = [20, 55, 25, 35, 20];
      const totalWidth = columnWidths.reduce((a, b) => a + b);
      
      // En-tête du tableau
      doc.setFillColor(...primaryColor);
      doc.rect(margin, yPosition, totalWidth, 8, "F");
      
      let x = margin;
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      
      headers.forEach((head, i) => {
        doc.text(head, x + 2, yPosition + 6);
        x += columnWidths[i];
      });
      
      yPosition += 10;
      
      // Données du tableau
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      
      data.forEach((entite, index) => {
        // Gestion de la pagination
        if (yPosition > pageHeight - 20) {
          doc.addPage();
          yPosition = margin;
          
          // Redessiner l'en-tête du tableau
          doc.setFillColor(...primaryColor);
          doc.rect(margin, yPosition, totalWidth, 8, "F");
          
          x = margin;
          doc.setTextColor(255, 255, 255);
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          
          headers.forEach((head, idx) => {
            doc.text(head, x + 2, yPosition + 6);
            x += columnWidths[idx];
          });
          
          yPosition += 10;
          doc.setFontSize(9);
          doc.setFont('helvetica', 'normal');
        }
        
        // Fond alterné pour les lignes
        if (index % 2 === 0) {
          doc.setFillColor(...softGray);
          doc.rect(margin, yPosition, totalWidth, 8, "F");
        }
        
        x = margin;
        
        // Données formatées
        const rowData = [
          entite.Code || "-",
          (entite.Nom || "-").substring(0, 30),
          entite.Type || "-",
          entite.Téléphone || "-",
          entite.Statut || "-"
        ];
        
        rowData.forEach((cell, i) => {
          let text = cell.toString();
          
          // Appliquer la couleur selon la colonne
          if (i === 4) { // STATUT
            if (entite.Statut === 'Active') {
              doc.setTextColor(...successColor);
            } else if (entite.Statut === 'Suspendue') {
              doc.setTextColor(...warningColor);
            } else {
              doc.setTextColor(...dangerColor);
            }
          } else {
            doc.setTextColor(...darkText);
          }
          
          doc.text(text, x + 2, yPosition + 6);
          x += columnWidths[i];
        });
        
        yPosition += 8;
      });
      
      // ===== PIED DE PAGE =====
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        
        doc.setFontSize(8);
        doc.setTextColor(100, 100, 100);
        
        doc.text(
          `Page ${i}/${pageCount} • ${new Date().toLocaleDateString('fr-FR')}`,
          pageWidth / 2,
          pageHeight - 10,
          { align: "center" }
        );
      }
      
      // ===== SAUVEGARDE =====
      const fileName = `entites_${new Date().toISOString().split('T')[0]}.pdf`;
      doc.save(fileName);
      
      return true;
      
    } catch (error) {
     
      return false;
    }
  };

  const downloadFile = (content, type, filename) => {
    const blob = new Blob([content], { type });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    setTimeout(() => URL.revokeObjectURL(link.href), 100);
  };

  // Composant pour l'en-tête triable
  const SortableHeader = ({ field, children }) => (
    <th 
      style={{ cursor: 'pointer', userSelect: 'none' }}
      onClick={() => handleSort(field)}
      className="position-relative"
    >
      {children}
      {sortField === field && (
        <span className="ms-1">
          {sortDirection === 'asc' ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </span>
      )}
    </th>
  );

  // Détails de l'entité
  const renderEntiteDetails = () => {
    if (!selectedEntite) return null;

    return (
      <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} size="lg">
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            <Building className="me-2" />
            Détails de l'entité
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Card className="border-0 bg-light mb-3">
                <Card.Body>
                  <h6 className="text-muted mb-3">Informations générales</h6>
                  <div className="mb-2">
                    <strong>ID:</strong>
                    <Badge bg="primary" className="ms-2">{selectedEntite.id}</Badge>
                  </div>
                  <div className="mb-2">
                    <strong>Code Entité:</strong>
                    <div className="fw-semibold mt-1">{selectedEntite.entite_id}</div>
                  </div>
                  <div className="mb-2">
                    <strong>Nom:</strong>
                    <div className="fw-semibold mt-1">{selectedEntite.nom}</div>
                  </div>
                  <div className="mb-2">
                    <strong>Type:</strong>
                    <div className="mt-1">{getTypeBadge(selectedEntite.type)}</div>
                  </div>
                  <div className="mb-2">
                    <strong>Statut:</strong>
                    <div className="mt-1">{getStatusBadge(selectedEntite.statut)}</div>
                  </div>
                  <div className="mb-2">
                    <strong>Code:</strong>
                    <div className="mt-1">
                      <Badge bg="light" text="dark" className="fw-semibold">{selectedEntite.code}</Badge>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="border-0 bg-light mb-3">
                <Card.Body>
                  <h6 className="text-muted mb-3">Contact</h6>
                  <div className="mb-2">
                    <strong>Téléphone:</strong>
                    <div className="mt-1">
                      <Phone className="me-2" size={14} />
                      {selectedEntite.telephone || 'Non spécifié'}
                    </div>
                  </div>
                  <div className="mb-2">
                    <strong>Email:</strong>
                    <div className="mt-1">
                      <Envelope className="me-2" size={14} />
                      {selectedEntite.email || 'Non spécifié'}
                    </div>
                  </div>
                  <div className="mb-2">
                    <strong>Adresse:</strong>
                    <div className="mt-1">
                      <Map className="me-2" size={14} />
                      {selectedEntite.adresse || 'Non spécifiée'}
                    </div>
                  </div>
                  <div className="mb-2">
                    <strong>Utilisateurs associés:</strong>
                    <div className="mt-1">
                      <Badge bg="info" className="ms-2">{selectedEntite.users_count || 0}</Badge>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Card className="border-0 bg-light">
                <Card.Body>
                  <h6 className="text-muted mb-3">Dates</h6>
                  <Row>
                    <Col md={6}>
                      <div className="mb-2">
                        <strong>Date création:</strong>
                        <div className="mt-1">
                          <Calendar className="me-2" size={14} />
                          {formatDateTime(selectedEntite.created_at)}
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-2">
                        <strong>Dernière modification:</strong>
                        <div className="mt-1">
                          <Calendar className="me-2" size={14} />
                          {formatDateTime(selectedEntite.updated_at)}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {selectedEntite.deleted_at && (
                    <div className="mt-2">
                      <strong>Date suppression:</strong>
                      <div className="mt-1 text-danger">
                        <Calendar className="me-2" size={14} />
                        {formatDateTime(selectedEntite.deleted_at)}
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
            Fermer
          </Button>
          <Button 
            variant="primary"
            onClick={() => {
              setShowDetailsModal(false);
              handleEditEntite(selectedEntite);
            }}
          >
            <Pencil className="me-2" />
            Modifier
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <React.Fragment>
      <Header />
      
      <div className="main main-app p-3 p-lg-4">
        {/* Container pour les notifications Toast */}
        <ToastContainer 
          // position="top-end"
          className="p-3"
           style={{ 
          zIndex: 9999,
          position: 'fixed',
          top: '20px',
          right: '20px'
        }}
        >
          {notifications.map((notification) => (
            <Toast
              key={notification.id}
              show={notification.show}
              onClose={() => hideNotification(notification.id)}
              delay={8000}
              autohide
              className={`bg-${notification.type === 'success' ? 'success' : 
                         notification.type === 'error' ? 'danger' :
                         notification.type === 'warning' ? 'warning' : 'info'} text-white`}
            >
              <Toast.Header className={`bg-${notification.type === 'success' ? 'success' : 
                         notification.type === 'error' ? 'danger' :
                         notification.type === 'warning' ? 'warning' : 'info'} text-white`}>
                {notification.type === 'success' ? <CheckCircle className="me-2" /> :
                 notification.type === 'error' ? <XCircle className="me-2" /> :
                 notification.type === 'warning' ? <ExclamationCircle className="me-2" /> :
                 <CheckCircle className="me-2" />}
                <strong className="me-auto">
                  {notification.type === 'success' ? 'Succès' : 
                   notification.type === 'error' ? 'Erreur' :
                   notification.type === 'warning' ? 'Attention' : 'Information'}
                </strong>
                <small>{new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</small>
              </Toast.Header>
              <Toast.Body className="text-white">
                {notification.message}
              </Toast.Body>
            </Toast>
          ))}
        </ToastContainer>

        {/* Alerte Bootstrap */}
        {alertMessage.show && (
          <div className="container-fluid mb-3">
            <Alert 
              variant={alertMessage.type} 
              dismissible 
              onClose={hideAlert}
              className="shadow-sm border-0"
            >
              <div className="d-flex align-items-center">
                {alertMessage.type === 'success' ? <Check className="me-2 fs-5" /> :
                 alertMessage.type === 'danger' ? <X className="me-2 fs-5" /> :
                 alertMessage.type === 'warning' ? <ExclamationCircle className="me-2 fs-5" /> :
                 <CheckCircle className="me-2 fs-5" />}
                <span className="fw-medium">{alertMessage.message}</span>
              </div>
            </Alert>
          </div>
        )}

       

        <div className="container-fluid">
         <Row className="mb-4">
  <Col md={12}>
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
      <div className="mb-3 mb-md-0">
        <ol className="breadcrumb fs-sm mb-1">
          <li className="breadcrumb-item"><Link to="/admin/dashboard">Tableau de bord</Link></li>
          <li className="breadcrumb-item"><Link to="/admin/entites">Entités</Link></li>
          <li className="breadcrumb-item active" aria-current="page">Gestion des entités</li>
        </ol>
        <h4 className="main-title mb-0 d-flex flex-wrap align-items-center gap-2">
          <Building className="me-2" />
          Gestion des Entités
        </h4>
        <p className="text-muted mb-0">
          {loading ? "Chargement..." : `${entites.length} entité(s)`}
          {useMockData && " (mode démonstration)"}
        </p>
      </div>

      <div className="d-flex flex-wrap gap-2 align-items-center">
        {/* Bouton de suppression multiple */}
        {selectedEntites.length > 0 && (
          <Button 
            variant="outline-danger" 
            size="sm"
            onClick={handleBulkDelete}
            className="d-flex align-items-center"
          >
            <Trash className="me-2" size={16} />
            Supprimer ({selectedEntites.length})
          </Button>
        )}
      
        {/* Bouton d'export */}
        <Dropdown>
          <Dropdown.Toggle 
            variant="outline-primary" 
            disabled={exportLoading || loading}
            className="d-flex align-items-center"
          >
            {exportLoading ? (
              <Spinner animation="border" size="sm" className="me-2" />
            ) : (
              <Download className="me-2" size={16} />
            )}
            {exportLoading ? 'Export...' : 'Exporter'}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => handleExport('csv')} disabled={exportLoading || loading}>
              <FileText className="me-2" size={14} />
              Export CSV
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleExport('excel')} disabled={exportLoading || loading}>
              <FileText className="me-2" size={14} />
              Export Excel
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleExport('pdf')} disabled={exportLoading || loading}>
              <FileText className="me-2" size={14} />
              Export PDF
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleExport('json')} disabled={exportLoading || loading}>
              <FileText className="me-2" size={14} />
              Export JSON
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        
        {/* Bouton d'ajout */}
        <Button 
          variant="success" 
          as={Link} to="/superAdmin/nouvelEntite"
          className="d-flex align-items-center"
          disabled={loading}
        >
          <PlusCircle className="me-2" size={16} />
          Nouvelle Entité
        </Button>
      </div>
    </div>
  </Col>
</Row>

          {/* Cartes de statistiques */}
          {/* {!loading && (
            <Row className="g-3 mb-4">
              <Col md={4} lg={4}>
                <Card className="border-0 shadow-sm">
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <h6 className="text-uppercase text-muted mb-2">Total Entités</h6>
                        <h2 className="mb-0">{stats.total}</h2>
                        <div className="mt-2">
                          <Badge bg="primary" className="fw-medium">
                            <Building className="me-1" size={12} />
                            Tous types
                          </Badge>
                        </div>
                      </div>
                      <div className="icon-container bg-primary-subtle">
                        <Building className="text-primary" size={28} />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              
              <Col md={4} lg={4}>
                <Card className="border-0 shadow-sm">
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <h6 className="text-uppercase text-muted mb-2">Statut Actif</h6>
                        <h2 className="mb-0">{stats.actives}</h2>
                        <div className="mt-2">
                          <Badge bg="success" className="fw-medium">
                            <CheckCircle className="me-1" size={12} />
                            Actives
                          </Badge>
                        </div>
                      </div>
                      <div className="icon-container bg-success-subtle">
                        <CheckCircle className="text-success" size={28} />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              
              <Col md={4} lg={4}>
                <Card className="border-0 shadow-sm">
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <h6 className="text-uppercase text-muted mb-2">Inactifs</h6>
                        <h2 className="mb-0">{stats.total - stats.actives}</h2>
                        <div className="mt-2">
                          <Badge bg="warning" className="fw-medium">
                            <Building className="me-1" size={12} />
                            Inactives
                          </Badge>
                        </div>
                      </div>
                      <div className="icon-container bg-warning-subtle">
                        <Building className="text-warning" size={28} />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )} */}

          {/* Tableau principal avec pagination en haut */}
          <Row>
            <Col md={12}>
              <Card className="shadow-sm border-0">
                <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center py-3">
                  <div className="d-flex align-items-center">
                    <Building className="me-2" />
                    <span className="fw-semibold">Liste des Entités ({filteredAndSortedItems.length})</span>
                    {loading && (
                      <Spinner animation="border" size="sm" className="ms-2 text-light" />
                    )}
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <div className="text-white-50 small d-flex align-items-center">
                      {selectedEntites.length > 0 && (
                        <span className="me-2">{selectedEntites.length} sélectionné(s)</span>
                      )}
                    </div>
                    
                    {/* Bouton rafraîchir déplacé ici */}
                    <Button 
                      variant="outline-light" 
                      size="sm" 
                      onClick={fetchEntites}
                      className="d-flex align-items-center"
                      disabled={loading}
                    >
                      {loading ? (
                        <Spinner animation="border" size="sm" className="me-2" />
                      ) : (
                        <ArrowClockwise className="me-2" size={14} />
                      )}
                      {loading ? '' : 'Actualiser'}
                    </Button>
                  </div>
                </Card.Header>
                
                <Card.Body className="p-0">
                  {/* Barre d'outils avec pagination EN HAUT */}
                  <div className="p-3 border-bottom bg-light">
                    <Row className="align-items-center">
                      <Col md={6}>
                        <InputGroup>
                          <InputGroup.Text>
                            <Search />
                          </InputGroup.Text>
                          <Form.Control
                            type="text"
                            placeholder="Rechercher une entité..."
                            value={filterText}
                            onChange={(e) => setFilterText(e.target.value)}
                            disabled={loading}
                          />
                          {filterText && (
                            <Button 
                              variant="outline-secondary" 
                              onClick={() => setFilterText('')}
                            >
                              <X size={14} />
                            </Button>
                          )}
                        </InputGroup>
                      </Col>
                      <Col md={6} className="text-end">
                        <div className="d-flex align-items-center justify-content-end gap-2">
                          <Dropdown>
                            <Dropdown.Toggle variant="outline-secondary" size="sm">
                              {itemsPerPage} par page
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item onClick={() => setItemsPerPage(5)}>5 par page</Dropdown.Item>
                              <Dropdown.Item onClick={() => setItemsPerPage(10)}>10 par page</Dropdown.Item>
                              <Dropdown.Item onClick={() => setItemsPerPage(25)}>25 par page</Dropdown.Item>
                              <Dropdown.Item onClick={() => setItemsPerPage(50)}>50 par page</Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                          
                          {/* Pagination en haut */}
                          {totalPages > 1 && (
                            <Pagination className="mb-0">
                              <Pagination.Prev 
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage(currentPage - 1)}
                              />
                              {[...Array(totalPages)].map((_, index) => (
                                <Pagination.Item
                                  key={index + 1}
                                  active={index + 1 === currentPage}
                                  onClick={() => setCurrentPage(index + 1)}
                                >
                                  {index + 1}
                                </Pagination.Item>
                              ))}
                              <Pagination.Next 
                                disabled={currentPage === totalPages}
                                onClick={() => setCurrentPage(currentPage + 1)}
                              />
                            </Pagination>
                          )}
                        </div>
                      </Col>
                    </Row>
                    
                    {/* Filtres supplémentaires */}
                    <Row className="mt-3">
                      <Col md={4}>
                        <Form.Select 
                          value={selectedType} 
                          onChange={(e) => setSelectedType(e.target.value)} 
                          disabled={loading}
                          size="sm"
                        >
                          {types.map(type => (
                            <option key={type.value} value={type.value}>{type.label}</option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col md={4}>
                        <Form.Select 
                          value={selectedStatus} 
                          onChange={(e) => setSelectedStatus(e.target.value)} 
                          disabled={loading}
                          size="sm"
                        >
                          {statuses.map(status => (
                            <option key={status.value} value={status.value}>{status.label}</option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col md={4}>
                        <Button
                          variant="outline-secondary"
                          onClick={() => {
                            setFilterText("");
                            setSelectedType("all");
                            setSelectedStatus("all");
                          }}
                          disabled={loading}
                          size="sm"
                          className="w-100"
                        >
                          Réinitialiser les filtres
                        </Button>
                      </Col>
                    </Row>
                  </div>

                  {/* Tableau */}
                  <div className="table-responsive">
                    <Table hover className="mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th style={{ width: '40px' }}>
                            {!loading && (
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  style={{
                                    borderRadius: '50%',
                                    width: '18px',
                                    height: '18px',
                                    cursor: 'pointer'
                                  }}
                                  checked={isAllSelected}
                                  ref={input => {
                                    if (input) {
                                      input.indeterminate = isSomeSelected;
                                    }
                                  }}
                                  onChange={handleSelectAll}
                                />
                              </div>
                            )}
                          </th>
                          <SortableHeader field="code">
                            <div className="d-flex align-items-center">
                              Code
                            </div>
                          </SortableHeader>
                          <SortableHeader field="nom">
                            <div className="d-flex align-items-center">
                              Entité
                            </div>
                          </SortableHeader>
                          <th>Adresse</th>
                          <SortableHeader field="telephone">
                            <div className="d-flex align-items-center">
                              Contact
                            </div>
                          </SortableHeader>
                          <SortableHeader field="created_at">
                            <div className="d-flex align-items-center">
                              Date création
                            </div>
                          </SortableHeader>
                          <SortableHeader field="statut">
                            <div className="d-flex align-items-center">
                              Statut
                            </div>
                          </SortableHeader>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="8" className="text-center py-5">
                              <div className="d-flex justify-content-center align-items-center">
                                <Spinner animation="border" variant="primary" className="me-3" />
                                <span className="text-muted">Chargement des entités...</span>
                              </div>
                            </td>
                          </tr>
                        ) : currentItems.length > 0 ? (
                          currentItems.map((entite) => {
                            const isActive = entite.statut === 'active';

                            return (
                              <tr key={entite.id}>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    style={{
                                      borderRadius: '50%',
                                      width: '18px',
                                      height: '18px',
                                      cursor: 'pointer'
                                    }}
                                    checked={selectedEntites.includes(entite.id)}
                                    onChange={() => handleSelectEntite(entite.id)}
                                  />
                                </td>
                                <td>
                                  <Badge bg="light" text="dark" className="fw-semibold">
                                    {entite.code}
                                  </Badge>
                                  <small className="d-block text-muted">ID: {entite.entite_id}</small>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0">
                                      <div className="bg-light rounded-circle d-flex align-items-center justify-content-center" style={{ width: 36, height: 36 }}>
                                        <Building size={16} className="text-muted" />
                                      </div>
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                      <h6 className="mb-1">{entite.nom}</h6>
                                      <div className="d-flex flex-column text-muted fs-sm">
                                        <div className="d-flex align-items-center">
                                          <Envelope size={12} className="me-1" />
                                          <span className="text-truncate">{entite.email || 'Non spécifié'}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <Map size={12} className="me-1" />
                                    <span className="text-truncate">{entite.adresse || 'Non spécifiée'}</span>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    <div className="fw-medium">{entite.telephone}</div>
                                    <small className="text-muted">
                                      Utilisateurs: {entite.users_count || 0}
                                    </small>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    <div className="fw-medium">{formatDate(entite.created_at)}</div>
                                    <small className="text-muted">
                                      {entite.updated_at && `Modifié: ${formatDate(entite.updated_at)}`}
                                    </small>
                                  </div>
                                </td>
                                <td>
                                  {getStatusBadge(entite.statut)}
                                </td>
                                <td>
                                  <div className="d-flex gap-1">
                                    <Button
  size="sm"
  variant="outline-primary"
  title="Voir détails"
  onClick={() => navigate(`/superAdmin/entite/${entite.entite_id}`)}
  className="d-flex align-items-center justify-content-center"
  style={{ width: '32px', height: '32px' }}
>
  <Eye size={14} />
</Button>
                                    <Button
                                      size="sm"
                                      variant="outline-info"
                                      title="Modifier"
                                      onClick={() => handleEditEntite(entite)}
                                      className="d-flex align-items-center justify-content-center"
                                      style={{ width: '32px', height: '32px' }}
                                    >
                                      <Pencil size={14} />
                                    </Button>
                                    {/* {isActive ? (
                                      <Button
                                        size="sm"
                                        variant="outline-warning"
                                        title="Bloquer"
                                        onClick={() => handleBlockEntite(entite)}
                                        className="d-flex align-items-center justify-content-center"
                                        style={{ width: '32px', height: '32px' }}
                                      >
                                        <XCircle size={14} />
                                      </Button>
                                    ) : (
                                      <Button
                                        size="sm"
                                        variant="outline-success"
                                        title="Débloquer"
                                        onClick={() => handleUnblockEntite(entite)}
                                        className="d-flex align-items-center justify-content-center"
                                        style={{ width: '32px', height: '32px' }}
                                      >
                                        <CheckCircle size={14} />
                                      </Button>
                                    )} */}
                                    <Button
                                      size="sm"
                                      variant="outline-danger"
                                      title="Supprimer"
                                      onClick={() => handleDeleteEntite(entite)}
                                      className="d-flex align-items-center justify-content-center"
                                      style={{ width: '32px', height: '32px' }}
                                    >
                                      <Trash size={14} />
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center py-5">
                              <Building size={48} className="text-muted" />
                              <p className="mt-3 text-muted">AUCUNE ENTITÉ TROUVÉE.</p>
                              <p className="text-muted mb-3">Aucune entité ne correspond aux critères de recherche.</p>
                              {filterText && (
                                <div>
                                  <Button 
                                    variant="outline-primary" 
                                    size="sm"
                                    onClick={() => setFilterText('')}
                                  >
                                    Réinitialiser la recherche
                                  </Button>
                                  <Button 
                                    variant="success" 
                                    size="sm"
                                    className="ms-2"
                                    onClick={handleAddEntite}
                                  >
                                    <PlusCircle className="me-2" />
                                    Ajouter une entité
                                  </Button>
                                </div>
                              )}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* Pagination en bas (optionnel) */}
                  {totalPages > 1 && (
                    <div className="p-3 border-top d-flex justify-content-between align-items-center">
                      <div className="text-muted small">
                        Affichage de {startIndex + 1} à {Math.min(startIndex + itemsPerPage, filteredAndSortedItems.length)} 
                        sur {filteredAndSortedItems.length} entités
                        {selectedEntites.length > 0 && (
                          <span className="ms-2 text-primary">• {selectedEntites.length} sélectionné(s)</span>
                        )}
                      </div>
                      <Pagination className="mb-0">
                        <Pagination.Prev 
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage(currentPage - 1)}
                        />
                        {[...Array(totalPages)].map((_, index) => (
                          <Pagination.Item
                            key={index + 1}
                            active={index + 1 === currentPage}
                            onClick={() => setCurrentPage(index + 1)}
                          >
                            {index + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next 
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage(currentPage + 1)}
                        />
                      </Pagination>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* Modal d'ajout */}
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="lg">
          <Modal.Header closeButton className="bg-success text-white">
            <Modal.Title>
              <PlusCircle className="me-2" />
              Ajouter une nouvelle entité
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nom de l'entité <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={newEntite.nom}
                      onChange={(e) => setNewEntite({...newEntite, nom: e.target.value})}
                      placeholder="Ex: Minerve Technologies"
                      required
                    />
                    <Form.Text className="text-muted">
                      Nom officiel de l'entité
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Type d'entité</Form.Label>
                    <Form.Select
                      value={newEntite.type}
                      onChange={(e) => setNewEntite({...newEntite, type: e.target.value})}
                    >
                      <option value="entreprise">Entreprise</option>
                      <option value="commune">Commune</option>
                      <option value="organisation">Organisation</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Téléphone <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="tel"
                      value={newEntite.telephone}
                      onChange={(e) => setNewEntite({...newEntite, telephone: e.target.value})}
                      placeholder="+241 XX XXX XXX"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      value={newEntite.email}
                      onChange={(e) => setNewEntite({...newEntite, email: e.target.value})}
                      placeholder="contact@entreprise.cd"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Adresse</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={newEntite.adresse}
                      onChange={(e) => setNewEntite({...newEntite, adresse: e.target.value})}
                      placeholder="Adresse complète"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Statut</Form.Label>
                    <Form.Select
                      value={newEntite.statut}
                      onChange={(e) => setNewEntite({...newEntite, statut: e.target.value})}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                      <option value="suspended">Suspendue</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddModal(false)}>
              Annuler
            </Button>
            <Button 
              variant="success" 
              onClick={handleSaveEntite}
              disabled={!newEntite.nom.trim() || !newEntite.telephone.trim()}
            >
              <Check className="me-2" />
              Enregistrer
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal d'édition */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title>
              <Pencil className="me-2" />
              Modifier l'entité
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedEntite && (
              <Form>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Nom de l'entité <span className="text-danger">*</span></Form.Label>
                      <Form.Control
                        type="text"
                        value={editEntite.nom}
                        onChange={(e) => setEditEntite({...editEntite, nom: e.target.value})}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Type d'entité</Form.Label>
                      <Form.Select
                        value={editEntite.type}
                        onChange={(e) => setEditEntite({...editEntite, type: e.target.value})}
                      >
                        <option value="entreprise">Entreprise</option>
                        <option value="commune">Commune</option>
                        <option value="organisation">Organisation</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Téléphone <span className="text-danger">*</span></Form.Label>
                      <Form.Control
                        type="tel"
                        value={editEntite.telephone}
                        onChange={(e) => setEditEntite({...editEntite, telephone: e.target.value})}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        value={editEntite.email}
                        onChange={(e) => setEditEntite({...editEntite, email: e.target.value})}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                
                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Adresse</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        value={editEntite.adresse}
                        onChange={(e) => setEditEntite({...editEntite, adresse: e.target.value})}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                
                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Statut</Form.Label>
                      <Form.Select
                        value={editEntite.statut}
                        onChange={(e) => setEditEntite({...editEntite, statut: e.target.value})}
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                        <option value="suspended">Suspendue</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button 
              variant="secondary" 
              onClick={() => setShowEditModal(false)}
              disabled={updating}
            >
              Annuler
            </Button>
            <Button 
              variant="primary" 
              onClick={handleUpdateEntite}
              disabled={!editEntite.nom.trim() || !editEntite.telephone.trim() || updating}
            >
              {updating ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Mise à jour...
                </>
              ) : (
                <>
                  <Check className="me-2" />
                  Mettre à jour
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de suppression */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <ExclamationCircle className="text-warning me-2" />
              Confirmer la suppression
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <Trash className="display-4 text-danger mb-3" size={48} />
              <h5>Êtes-vous sûr de vouloir supprimer cette entité ?</h5>
              {entiteToDelete && (
                <div className="mt-3 p-3 bg-light rounded">
                  <strong>{entiteToDelete.nom}</strong>
                  <br />
                  <small className="text-muted">{entiteToDelete.code}</small>
                  <br />
                  <small className="text-muted">{entiteToDelete.telephone}</small>
                  <div className="mt-2">
                    {getTypeBadge(entiteToDelete.type)}
                    <span className="ms-2">{getStatusBadge(entiteToDelete.statut)}</span>
                  </div>
                </div>
              )}
              <p className="text-muted mt-3">
                Cette action est irréversible et supprimera définitivement l'entité.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              <X className="me-2" />
              Annuler
            </Button>
            <Button 
              variant="danger" 
              onClick={handleConfirmDelete}
              disabled={deleting}
            >
              {deleting ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Suppression...
                </>
              ) : (
                <>
                  <Trash className="me-2" />
                  Supprimer définitivement
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de suppression multiple */}
        <Modal show={showBulkDeleteModal} onHide={() => setShowBulkDeleteModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <ExclamationCircle className="text-warning me-2" />
              Confirmer la suppression multiple
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <Trash className="display-4 text-danger mb-3" size={48} />
              <h5>Supprimer {selectedEntites.length} entité(s) ?</h5>
              <p className="text-muted mt-3">
                Vous êtes sur le point de supprimer définitivement {selectedEntites.length} entité(s).
                <br />
                <strong>Cette action est irréversible.</strong>
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowBulkDeleteModal(false)}>
              <X className="me-2" />
              Annuler
            </Button>
            <Button variant="danger" onClick={handleConfirmBulkDelete}>
              <Trash className="me-2" />
              Supprimer {selectedEntites.length} entité(s)
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de blocage */}
        <Modal show={showBlockModal} onHide={() => setShowBlockModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <ExclamationCircle className="text-warning me-2" />
              Bloquer l'entité
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <XCircle className="display-4 text-warning mb-3" size={48} />
              <h5>Bloquer cette entité ?</h5>
              {entiteToBlock && (
                <div className="mt-3 p-3 bg-light rounded">
                  <strong>{entiteToBlock.nom}</strong>
                  <br />
                  <small className="text-muted">{entiteToBlock.code}</small>
                </div>
              )}
              <p className="text-muted mt-3">
                L'entité sera marquée comme inactive.
                <br />
                <small>Cette action peut être annulée à tout moment.</small>
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowBlockModal(false)}>
              <X className="me-2" />
              Annuler
            </Button>
            <Button variant="warning" onClick={handleConfirmBlock}>
              <XCircle className="me-2" />
              Bloquer l'entité
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de déblocage */}
        <Modal show={showUnblockModal} onHide={() => setShowUnblockModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <CheckCircle className="text-success me-2" />
              Débloquer l'entité
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <CheckCircle className="display-4 text-success mb-3" size={48} />
              <h5>Débloquer cette entité ?</h5>
              {entiteToBlock && (
                <div className="mt-3 p-3 bg-light rounded">
                  <strong>{entiteToBlock.nom}</strong>
                  <br />
                  <small className="text-muted">{entiteToBlock.code}</small>
                </div>
              )}
              <p className="text-muted mt-3">
                L'entité sera réactivée.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowUnblockModal(false)}>
              <X className="me-2" />
              Annuler
            </Button>
            <Button variant="success" onClick={handleConfirmUnblock}>
              <CheckCircle className="me-2" />
              Débloquer l'entité
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de détails */}
        {renderEntiteDetails()}

        <style>{`
          .icon-container {
            width: 56px;
            height: 56px;
            border-radius: 12px;
            display: flex;
            align-items-center: center;
            justify-content: center;
          }

          @media (max-width: 768px) {
            .icon-container {
              width: 48px;
              height: 48px;
            }
          }
        `}</style>
        <Footer />
      </div>
    </React.Fragment>
  );
}